import React, { useState } from 'react';
import './style.css';
import clsx from 'clsx';
import { ReactComponent as TopArrow } from '../../../../assets/images/toparrow.svg';
import { ReactComponent as DownArrow } from '../../../../assets/images/downarrow.svg';

function TeamInputNumber(props) {
  const [num1, setNum1] = useState('3');
  const {
    placeholder = 'placeholder',
    title = 'title',
    name = 'name',
    id = 'id',
    className,
    onMouseDown,
    onBlur,
    value,
    setGetChatLimit,
  } = props;

  const handleIncrease = () => {
    const newValue = Number(value) + 1;
    setGetChatLimit(newValue);
  };

  const handleDecrease = () => {
    if(value > 1) {
      const newValue = Number(value) - 1;
      setGetChatLimit(newValue);
    }
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue)) {
      setNum1(Number(newValue));
      setGetChatLimit(Number(newValue));
    }
  };

  return (
    <div className="Input-headingcontainer-edit">
      <p className="input-div">{title}</p>
      <div className="input-container-edit">
        <div className="svg-containerTop" onClick={() => handleIncrease()}>
          <TopArrow />
        </div>
        <div className="svg-containerDown" onClick={() => handleDecrease()}>
          <DownArrow />
        </div>
        <input
          placeholder={placeholder}
          onBlur={onBlur}
          name={name}
          onMouseDown={onMouseDown}
          id={id}
          className={clsx(className, 'input-new-edit')}
          type="number"
          min="0"
          value={value}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
}

export default TeamInputNumber;
